import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { useSession } from "@/context/AuthContext";
import {
  LayoutGrid, MessagesSquare, FileBarChart, BellRing, Radio, Table2, BookOpen,
  Network, Package, Share2, Users, Activity, CreditCard, ScrollText, Settings2, FileText,
} from "lucide-react";

const GROUPS = [
  {
    heading: "Navigate",
    items: [
      { label: "Overview", to: "/dashboard", icon: LayoutGrid, kw: "home dashboard" },
      { label: "Ask Sema", to: "/chat", icon: MessagesSquare, kw: "chat query ask question" },
      { label: "Reports", to: "/reports", icon: FileBarChart, kw: "scheduled reports" },
      { label: "Alerts", to: "/alerts", icon: BellRing, kw: "alerts watch metric" },
      { label: "Signals", to: "/signals/queue", icon: Radio, kw: "signals registry review" },
      { label: "Schema", to: "/schema", icon: Table2, kw: "tables columns" },
      { label: "Glossary", to: "/glossary", icon: BookOpen, kw: "dictionary terms definitions" },
      { label: "Semantics", to: "/semantics", icon: Network, kw: "graph joins" },
      { label: "Semantic packs", to: "/semantics/packs", icon: Package, kw: "industry packs sector" },
      { label: "Metrics", to: "/semantics/metrics", icon: Network, kw: "governed metrics" },
      { label: "Graph", to: "/graph", icon: Share2, kw: "relationships lineage" },
      { label: "Team", to: "/team", icon: Users, kw: "members roles" },
    ],
  },
  {
    heading: "System",
    items: [
      { label: "System health", to: "/health", icon: Activity, kw: "status uptime workers" },
      { label: "Billing & plan", to: "/settings/billing", icon: CreditCard, kw: "billing plan upgrade trial" },
      { label: "Audit log", to: "/settings/audit", icon: ScrollText, kw: "audit events" },
      { label: "Workspace settings", to: "/settings/workspace", icon: Settings2, kw: "settings rename llm" },
      { label: "Docs", to: "/docs", icon: FileText, kw: "documentation help guide" },
    ],
  },
];

export function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useSession();

  useEffect(() => {
    const onKey = (e) => {
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  if (!user) return null;

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Jump to…  (⌘K / Ctrl-K)" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No matches.</CommandEmpty>
        {GROUPS.map((g) => (
          <CommandGroup key={g.heading} heading={g.heading}>
            {g.items.map((it) => (
              <CommandItem
                key={it.to + it.label}
                value={`${it.label} ${it.kw}`}
                onSelect={() => go(it.to)}
                data-testid={`command-item-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <it.icon className="mr-2 h-4 w-4 text-accent" />
                {it.label}
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
